import {useEffect} from "react";

export function usePageTitle(name: string) {
    useEffect(() => {
        document.title = name;

        return () => {
            if(document.title === name) {
                document.title = "Tykel";
            }
        }
    }, [name]);
}

export function titleHelperClip(value: string | undefined, length: number) {
    if(!value) return "...";
    if(value.length <= length) return value;
    return value.slice(0, length) + "...";
}

export function PageTitle(props: {
    title: string;
}) {
    usePageTitle(props.title);
    return null;
}